import script from "./EditorElement.vue?vue&type=script&lang=js"
export * from "./EditorElement.vue?vue&type=script&lang=js"

import "./EditorElement.vue?vue&type=style&index=0&id=9a0e0c88&lang=scss"

const __exports__ = script;

export default __exports__